import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { defineComponent as _defineComponent } from 'vue';
import { MetricReportingPeriodType } from '~/types/types';
import { useShowDebugging } from '~/functions/accounts';
export default /*#__PURE__*/_defineComponent({
  __name: 'TableForPortfolio',
  props: {
    portfolio: null
  },
  setup: function setup(__props) {
    var props = __props;
    var _useNuxtApp = useNuxtApp(),
      $nuxt = _useNuxtApp.$nuxt;
    var route = useRoute();
    var router = useRouter();
    var openedItem = ref(null);
    var openedPeriod = ref('');
    var dialog = ref(false);
    var groupBy = ref(null);
    var customKpiId = ref(null);
    var isAggregationDialogOpen = ref(false);
    var createMetricDialog = ref(false);
    var newMetricItem = ref({
      nameI18n: {},
      descriptionI18n: {},
      usageGuidanceI18n: {}
    });
    var handleCreateMetricUpsert = function handleCreateMetricUpsert(metricId) {
      customKpiId.value = metricId;
      isAggregationDialogOpen.value = true;
      createMetricDialog.value = false;
    };
    var showDebugging = useShowDebugging();
    var companyAssigneeIds = computed(function () {
      return (props.portfolio.ventureLinks || []).map(function (ventureLink) {
        var _ventureLink$venture;
        return ventureLink === null || ventureLink === void 0 ? void 0 : (_ventureLink$venture = ventureLink.venture) === null || _ventureLink$venture === void 0 ? void 0 : _ventureLink$venture.id;
      }).filter(function (id) {
        return !!id;
      });
    });
    var kpiType = computed(function () {
      var isPortfolioAssigned = route.query.kpiAssigned === 'portfolio';
      var isAssignment = route.query.type === 'assignment';
      if (isPortfolioAssigned) return 'fund-gp';
      if (isAssignment) return 'company-data';
      return 'aggregation';
    });
    var updateKpiType = function updateKpiType(value) {
      var query = _objectSpread({}, route.query);
      if (value === 'fund-gp') {
        query.kpiAssigned = 'portfolio';
        query.type = '';
      } else if (value === 'company-data') {
        query.kpiAssigned = '';
        query.type = 'assignment';
      } else {
        query.kpiAssigned = '';
        query.type = '';
      }
      router.push({
        query: query
      });
    };
    var reloadPage = function reloadPage() {
      window.location.reload();
    };
    var refetchList = function refetchList() {
      $nuxt.$emit('refetch-metric-aggregations');
    };
    return {
      __sfc: true,
      props: props,
      $nuxt: $nuxt,
      route: route,
      router: router,
      openedItem: openedItem,
      openedPeriod: openedPeriod,
      dialog: dialog,
      groupBy: groupBy,
      customKpiId: customKpiId,
      isAggregationDialogOpen: isAggregationDialogOpen,
      createMetricDialog: createMetricDialog,
      newMetricItem: newMetricItem,
      handleCreateMetricUpsert: handleCreateMetricUpsert,
      showDebugging: showDebugging,
      companyAssigneeIds: companyAssigneeIds,
      kpiType: kpiType,
      updateKpiType: updateKpiType,
      reloadPage: reloadPage,
      refetchList: refetchList,
      MetricReportingPeriodType: MetricReportingPeriodType
    };
  }
});